<div class="help-wrapper p-3">
  <!-- Enhanced Header Section with Integrated Signature -->
  <div class="template-header help-header">
    <div class="header-content">
      <h1 class="template-title">Command Documentation</h1>
      <p class="template-description">
        Explore all available commands organized by role or usage type. Use the search to quickly find what you need.
      </p>
    </div>
    
    <!-- Integrated Signature Card -->
    <div class="signature-card">
      <div class="signature-header">
        <mat-icon class="signature-icon">code</mat-icon>
        <h3 class="signature-title">Command Syntax Guide</h3>
      </div>
      <div class="signature-grid">
        <div class="signature-item">
          <code class="signature-code">&lt; argument &gt;</code>
          <span class="signature-label">Required argument</span>
        </div>
        <div class="signature-item">
          <code class="signature-code">[ argument ]</code>
          <span class="signature-label">Optional argument</span>
        </div>
        <div class="signature-item">
          <code class="signature-code">[ argument... ]</code>
          <span class="signature-label">Multiple arguments</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Enhanced Controls Section -->
  <div class="controls-section p-3">
    <div class="controls-wrapper">
      <!-- View Toggle with Material Tabs -->
      <div class="view-toggle-container">
        <mat-tab-group [selectedIndex]="toggleValue ? 1 : 0" (selectedIndexChange)="toggleValue = $event === 1" class="view-tabs">
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">category</mat-icon>
              <span class="tab-label">By Usage</span>
            </ng-template>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">security</mat-icon>
              <span class="tab-label">By Role</span>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>

      <!-- Enhanced Search Filter -->
      <div class="search-container">
        <mat-form-field class="filter-field" appearance="outline">
          <mat-label>Search commands</mat-label>
          <input 
            matInput 
            placeholder="Type command name, description..." 
            (input)="updateFilterText($event)"
            #filterInput
            autocomplete="off"
            aria-label="Filter commands" />
          <mat-icon matPrefix class="search-icon">search</mat-icon>
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- Commands by Permission -->
  <div class="commands-section" *ngIf="toggleValue">
    <div class="section-header-enhanced">
      <div class="section-title-wrapper">
        <mat-icon class="section-icon-large">security</mat-icon>
        <div>
          <h2 class="section-title">Commands by Role</h2>
          <p class="section-subtitle">Commands organized by required permission level</p>
        </div>
      </div>
    </div>
    <mat-accordion multi class="commands-accordion">
      <mat-expansion-panel 
        *ngFor="let entry of permissionOptions; let i = index" 
        [expanded]="i === 0"
        class="command-panel">
        <mat-expansion-panel-header class="panel-header-enhanced">
          <mat-panel-title class="panel-title-enhanced">
            <mat-icon class="panel-icon">{{ getRoleIcon(entry.text) }}</mat-icon>
            <span>{{ entry.text }}</span>
          </mat-panel-title>
          <mat-panel-description class="panel-description-enhanced">
            <span class="command-count-badge">{{ entry.data.length }}</span>
            <span class="command-count-text">command{{ entry.data.length !== 1 ? 's' : '' }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
          <app-commands [commands]="entry.data"></app-commands>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <!-- Commands by Usage -->
  <div class="commands-section" *ngIf="!toggleValue">
    <div class="section-header-enhanced">
      <div class="section-title-wrapper">
        <mat-icon class="section-icon-large">category</mat-icon>
        <div>
          <h2 class="section-title">Commands by Usage</h2>
          <p class="section-subtitle">Commands organized by their purpose and scope</p>
        </div>
      </div>
    </div>
    <mat-accordion multi class="commands-accordion">
      <mat-expansion-panel 
        *ngFor="let entry of usageOptions; let i = index" 
        [expanded]="i === 0"
        class="command-panel">
        <mat-expansion-panel-header class="panel-header-enhanced">
          <mat-panel-title class="panel-title-enhanced">
            <mat-icon class="panel-icon">{{ getUsageIcon(entry.text) }}</mat-icon>
            <span>{{ entry.text }}</span>
          </mat-panel-title>
          <mat-panel-description class="panel-description-enhanced">
            <span class="command-count-badge">{{ entry.data.length }}</span>
            <span class="command-count-text">command{{ entry.data.length !== 1 ? 's' : '' }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
          <app-commands [commands]="entry.data"></app-commands>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
